import { ApiClient } from '@api/client';

export function fetchMonthlyMessagesCount() {
  return ApiClient.get('/v2/monthly_message_count', null, {
    credentials: 'include',
  });
}
